import { render, staticRenderFns } from "./jzSet.vue?vue&type=template&id=0a9ef020&scoped=true&"
import script from "./jzSet.vue?vue&type=script&lang=js&"
export * from "./jzSet.vue?vue&type=script&lang=js&"
import style0 from "./jzSet.vue?vue&type=style&index=0&id=0a9ef020&prod&lang=scss&scoped=true&"
import style1 from "./jzSet.vue?vue&type=style&index=1&id=0a9ef020&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ef020",
  null
  
)

export default component.exports